import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { clsx } from 'clsx';

import type { ICustomGroupMoreNode } from '../interfaces/ICustomGroupMoreNode';

import styles from '../sass/CustomGroupMoreNode.module.scss';

function CustomGroupMoreNode({ data }: ICustomGroupMoreNode) {
  const { t } = useTranslation();
  const { groupId, hiddenCount, onShowMore } = data;

  const handleShowMore = () => {
    onShowMore(groupId);
  };

  return (
    <button
      type="button"
      className={clsx(styles.button, 'nopan', 'nodrag')}
      aria-label={t('valueChainMap.groupShowMoreItems', { count: hiddenCount })}
      onClick={handleShowMore}
    >
      {t('valueChainMap.groupShowMoreItems', { count: hiddenCount })}
    </button>
  );
}

export default memo(CustomGroupMoreNode);
